import styled from 'styled-components';
import { Box } from '@bechtel/gds';

export const MapContainerStyled = styled(Box)`
  min-height: 265px;
`;
